import React from 'react';
import { Grant } from '@meprism/shared/src/redux/product/ProductTypes';
import DashboardCard from './DashboardStatsCard';

const TOTAL_BROKERS = 400;

interface OptOutRequestsCardProps {
  optOutsSubmitted: number;
  pendingCount: number;
  grant: Grant | undefined;
}

const OptOutRequestsCard: React.FC<OptOutRequestsCardProps> = ({
  optOutsSubmitted,
  pendingCount,
}) => {
  const progress = (optOutsSubmitted / TOTAL_BROKERS) * 100;
  const displayPending = optOutsSubmitted === 0 ? '400+' : pendingCount;

  return (
    <DashboardCard
      heading="Expanded Coverage Progress"
      tooltipText="This section shows how many opt out requests have been submitted to data brokers on your behalf. Pending requests are either currently being sent or were not covered under your subscription plan."
      mainStatValue={optOutsSubmitted}
      mainStatLabel="OptOut Requests Submitted"
      progress={progress}
      leftStat={{ label: 'Requests Pending', value: displayPending, barColor: '#7459D9' }}
      rightStat={{ label: 'Brokers Covered', value: '400+', barColor: '#7459D980' }}
    />
  );
};

export default OptOutRequestsCard;
